import React, { useRef, useState } from "react";

export const Logo = () => {
  return (
    <a
      name="home"
      href="/#"
      onClick={() => window.scrollTo(0, 0)}
      aria-label="home-button"
    >
      <svg
        width="55"
        height="28"
        viewBox="0 0 55 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.09222 27.354V5.8171H0.0546875V0.646484H14.2628V27.354H9.09222Z"
          fill="white"
        />
        <path
          d="M24.8324 0.646484H18.1813V5.8171H24.8324V0.646484Z"
          fill="white"
        />
        <path
          d="M31.3399 27.354V15.6833H23.3556V27.354H18.1813V10.5384H31.3399V0.646484H36.5142V27.354H31.3399Z"
          fill="white"
        />
        <path
          d="M54.6408 11.4149H40.4327V16.5855H54.6408V11.4149Z"
          fill="white"
        />
        <path
          d="M54.6408 0.646484H40.4327V5.8171H54.6408V0.646484Z"
          fill="white"
        />
        <path
          d="M54.6408 22.1833H40.4326V27.354H54.6408V22.1833Z"
          fill="white"
        />
        <path
          d="M9.09222 27.354V5.8171H0.0546875V0.646484H14.2628V27.354H9.09222Z"
          fill="white"
        />
        <path
          d="M24.8324 0.646484H18.1813V5.8171H24.8324V0.646484Z"
          fill="white"
        />
        <path
          d="M31.3399 27.354V15.6833H23.3556V27.354H18.1813V10.5384H31.3399V0.646484H36.5142V27.354H31.3399Z"
          fill="white"
        />
        <path
          d="M54.6408 11.4149H40.4327V16.5855H54.6408V11.4149Z"
          fill="white"
        />
        <path
          d="M54.6408 0.646484H40.4327V5.8171H54.6408V0.646484Z"
          fill="white"
        />
        <path
          d="M54.6408 22.1833H40.4326V27.354H54.6408V22.1833Z"
          fill="white"
        />
      </svg>
    </a>
  );
};

export const NavIcon = ({ children }) => {
  const ref = useRef();
  const [clicked, isClicked] = useState(false);

  function menuOpen() {
    setTimeout(() => {
      isClicked(!clicked);

      ref.current.classList.toggle("clicked");
    }, [60]);
  }
  return (
    <div ref={ref} className="hamburger">
      <button
        name="menu-open"
        onClick={menuOpen}
        onBlur={menuOpen}
        aria-label="menu-open"
      >
        <svg
          className="menu-icon"
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 9.05908H29" stroke="white" strokeWidth="2" />
          <path d="M0 18.075H29" stroke="white" strokeWidth="2" />
        </svg>
      </button>
    </div>
  );
};

export const SocialIcons = () => {
  return (
    <div className="social-icons">
      <a
        name="instagram"
        href="https://www.instagram.com/thehumanexperienceagencyltd?igsh=MTNha3ZuNnA1aWoweg%3D%3D&utm_source=qr"
        aria-label="instagram"
      >
        <svg
          name="Instagram"
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_123_248)">
            <path
              d="M11.3583 2.87493C14.2779 2.87493 14.6236 2.88773 15.7718 2.93895C16.8389 2.98591 17.4151 3.16518 17.7993 3.31457C18.3072 3.51091 18.6743 3.74994 19.0541 4.12982C19.4383 4.51397 19.6731 4.87678 19.8694 5.38471C20.0188 5.76886 20.1981 6.34935 20.245 7.41217C20.2962 8.56462 20.309 8.91036 20.309 11.8256C20.309 14.7452 20.2962 15.0909 20.245 16.2391C20.1981 17.3062 20.0188 17.8824 19.8694 18.2666C19.6731 18.7745 19.434 19.1416 19.0541 19.5214C18.67 19.9056 18.3072 20.1404 17.7993 20.3367C17.4151 20.4861 16.8346 20.6654 15.7718 20.7123C14.6193 20.7635 14.2736 20.7763 11.3583 20.7763C8.43879 20.7763 8.09306 20.7635 6.94488 20.7123C5.87779 20.6654 5.30157 20.4861 4.91742 20.3367C4.40949 20.1404 4.04241 19.9013 3.66253 19.5214C3.27838 19.1373 3.04362 18.7745 2.84727 18.2666C2.69788 17.8824 2.51861 17.3019 2.47166 16.2391C2.42044 15.0866 2.40764 14.7409 2.40764 11.8256C2.40764 8.90609 2.42044 8.56035 2.47166 7.41217C2.51861 6.34509 2.69788 5.76886 2.84727 5.38471C3.04362 4.87678 3.28264 4.5097 3.66253 4.12982C4.04668 3.74567 4.40949 3.51091 4.91742 3.31457C5.30157 3.16518 5.88206 2.98591 6.94488 2.93895C8.09306 2.88773 8.43879 2.87493 11.3583 2.87493ZM11.3583 0.907227C8.39184 0.907227 8.0205 0.920032 6.85524 0.971252C5.69425 1.02247 4.89608 1.21028 4.20461 1.47918C3.48326 1.76089 2.87288 2.13224 2.26678 2.74261C1.65641 3.34871 1.28506 3.95909 1.00335 4.67617C0.734448 5.37191 0.546642 6.16582 0.495422 7.3268C0.444201 8.49633 0.431396 8.86767 0.431396 11.8342C0.431396 14.8007 0.444201 15.172 0.495422 16.3373C0.546642 17.4982 0.734448 18.2964 1.00335 18.9879C1.28506 19.7092 1.65641 20.3196 2.26678 20.9257C2.87288 21.5318 3.48326 21.9074 4.20034 22.1849C4.89608 22.4538 5.68999 22.6416 6.85097 22.6928C8.01623 22.744 8.38757 22.7568 11.3541 22.7568C14.3206 22.7568 14.6919 22.744 15.8572 22.6928C17.0182 22.6416 17.8163 22.4538 18.5078 22.1849C19.2249 21.9074 19.8353 21.5318 20.4414 20.9257C21.0475 20.3196 21.4231 19.7092 21.7005 18.9922C21.9694 18.2964 22.1572 17.5025 22.2084 16.3415C22.2597 15.1763 22.2725 14.8049 22.2725 11.8384C22.2725 8.87194 22.2597 8.5006 22.2084 7.33534C22.1572 6.17435 21.9694 5.37617 21.7005 4.6847C21.4316 3.95909 21.0603 3.34871 20.4499 2.74261C19.8438 2.13651 19.2334 1.76089 18.5163 1.48345C17.8206 1.21455 17.0267 1.02674 15.8657 0.97552C14.6962 0.920032 14.3248 0.907227 11.3583 0.907227Z"
              fill="white"
            />
            <path
              d="M11.3592 6.2207C8.26039 6.2207 5.74634 8.73475 5.74634 11.8336C5.74634 14.9324 8.26039 17.4464 11.3592 17.4464C14.458 17.4464 16.9721 14.9324 16.9721 11.8336C16.9721 8.73475 14.458 6.2207 11.3592 6.2207ZM11.3592 15.4745C9.34881 15.4745 7.71831 13.844 7.71831 11.8336C7.71831 9.82318 9.34881 8.19267 11.3592 8.19267C13.3696 8.19267 15.0001 9.82318 15.0001 11.8336C15.0001 13.844 13.3696 15.4745 11.3592 15.4745Z"
              fill="white"
            />
            <path
              d="M18.5028 5.99886C18.5028 6.72448 17.9138 7.30924 17.1925 7.30924C16.4668 7.30924 15.8821 6.72021 15.8821 5.99886C15.8821 5.27324 16.4711 4.68848 17.1925 4.68848C17.9138 4.68848 18.5028 5.27751 18.5028 5.99886Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_123_248">
              <rect
                width="21.8539"
                height="21.8539"
                fill="white"
                transform="translate(0.431152 0.907227)"
              />
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        name="linkedin"
        href="https://www.linkedin.com/company/the-agency-live/about/"
        aria-label="linkedin"
      >
        <svg
          name="LinkedIn"
          width="21"
          height="23"
          viewBox="0 0 21 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.53294 5.77593C3.85512 5.77593 4.92696 4.68603 4.92696 3.34158C4.92696 1.99712 3.85512 0.907227 2.53294 0.907227C1.21076 0.907227 0.138916 1.99712 0.138916 3.34158C0.138916 4.68603 1.21076 5.77593 2.53294 5.77593ZM4.5854 7.54619H0.481359V22.7609H4.5854V7.54619ZM16.896 22.7609H21V13.4246C21 6.1492 13.3391 6.412 11.4239 9.99437V7.54619H7.31988V22.7609H11.4239V15.0152C11.4239 10.7136 16.896 10.354 16.896 15.0152V22.7609Z"
            fill="white"
          />
        </svg>
      </a>
    </div>
  );
};
